import { Modal, Tag } from "antd";
import { forwardRef, useImperativeHandle, useMemo, useState } from "react";
import { autoSubFlags } from "../../constants/autoSubFlags";

function SubFlagsModal(
  {
    allRoadmapFlags = [],
    findFlag = (id) => null,
    terms,
    setTerms = () => {},
    resetFlagsList = (newTerms) => null,
  },
  ref
) {
  const [show, setShow] = useState(false);
  const [checkList, setCheckList] = useState([]);

  useImperativeHandle(
    ref,
    () => ({
      toggleShow: () => setShow((p) => !p),
    }),
    []
  );

  const currentSubFlagsList = useMemo(
    () =>
      autoSubFlags.map((el) => {
        const flagsStat = [el.mainFlagId, ...el.subFlags].filter((e) =>
          allRoadmapFlags.includes(e)
        );

        return {
          validToChange: flagsStat.length > 1,
          mainFlag: {
            id: el.mainFlagId,
            exists: flagsStat.includes(el.mainFlagId),
          },
          subFlags: el.subFlags.map((fl) => ({
            id: fl,
            exists: flagsStat.includes(fl),
          })),
        };
      }),
    [allRoadmapFlags]
  );

  const findFlagPosition = (flagId) => {
    for (const tempTermIndex of [1, 2, 3, 4]) {
      const rowIndexExists = terms[`term${tempTermIndex}`]?.flags.findIndex(
        (e) => e.id === flagId
      );
      if (rowIndexExists === -1) continue;
      return { termIndex: tempTermIndex, rowIndex: rowIndexExists };
    }
    return { termIndex: 1, rowIndex: 0 };
  };

  const handleCheckBox = (id) => {
    if (checkList.includes(id)) {
    }

    setCheckList((prev) =>
      checkList.includes(id) ? prev.filter((e) => e !== id) : [...prev, id]
    );
  };

  const okHandler = () => {
    setShow(false);
    const needToMerge = currentSubFlagsList.filter((e) =>
      checkList.includes(e.mainFlag.id)
    );

    const allTermsFullFlags = [1, 2, 3, 4]
      .map((e) => terms[`term${e}`].flags)
      .flat();

    // loop
    for (const el of needToMerge) {
      const allIdList = [el.mainFlag.id, ...el.subFlags.map((e) => e.id)];
      // find lowest index and term
      const positions = allIdList
        .filter((e) => allRoadmapFlags.includes(e))
        .map((id) => findFlagPosition(id));

      const termIndex = Math.min(...positions.map((e) => e.termIndex));
      const rowIndex = Math.min(
        ...positions
          .filter((e) => e.termIndex === termIndex)
          .map((e) => e.rowIndex)
      );

      console.log({ el, positions, termIndex, rowIndex });

      // remove all other
      terms = {
        term1: {
          ...terms.term1,
          flags: terms.term1.flags.filter((e) => !allIdList.includes(e.id)),
        },
        term2: {
          ...terms.term2,
          flags: terms.term2.flags.filter((e) => !allIdList.includes(e.id)),
        },
        term3: {
          ...terms.term3,
          flags: terms.term3.flags.filter((e) => !allIdList.includes(e.id)),
        },
        term4: {
          ...terms.term4,
          flags: terms.term4.flags.filter((e) => !allIdList.includes(e.id)),
        },
      };

      // put in
      const flagToInsert =
        allTermsFullFlags.find((e) => e.id === el.mainFlag.id) ??
        findFlag(el.mainFlag.id);
      const clonedArray = [...terms[`term${termIndex}`].flags];
      clonedArray.splice(rowIndex, 0, { ...flagToInsert, merged: true });
      terms[`term${termIndex}`].flags = clonedArray;
    }

    // set term
    setTerms(terms);
    resetFlagsList(terms);
  };

  return (
    <>
      <Modal
        centered
        title="ادغام کارت ها"
        open={show}
        destroyOnClose
        width={"50rem"}
        onCancel={() => setShow(false)}
        onOk={okHandler}
      >
        <div
          style={{
            display: "flex",
            marginTop: "1rem",
            justifyContent: "space-between",
            width: "100%",
            paddingBottom: "0.2rem",
            borderBottom: "1px solid rgba(0,0,0, 0.5)",
          }}
        >
          <div style={{ width: "10%" }}>#</div>
          <div style={{ width: "30%" }}>کارت اصلی</div>
          <div style={{ width: "50%" }}>کارت های فرعی</div>
        </div>

        {currentSubFlagsList
          .filter((e) => e.validToChange)
          .map((el) => {
            const mainFlag = findFlag(el.mainFlag.id);
            const subFlags = el.subFlags.map((e) => ({
              ...e,
              ...findFlag(e.id),
            }));
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "0.5rem",
                  paddingBottom: "0.5rem",

                  borderBottom: "0.5px solid rgba(0,0,0, 0.3)",
                }}
              >
                <div
                  style={{
                    width: "10%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={checkList.includes(el.mainFlag.id)}
                    onChange={() => handleCheckBox(el.mainFlag.id)}
                  />
                </div>
                <div style={{ width: "30%" }}>
                  <Tag color={el.mainFlag.exists ? "green" : "red"}>
                    {mainFlag?.title ?? `یافت نشد: ${el.mainFlag.id}`}
                  </Tag>
                </div>
                <div style={{ width: "50%" }}>
                  {subFlags.map((e, i) => (
                    <Tag key={i} color={e.exists ? "green" : "red"}>
                      {e?.title ?? `یافت نشد: ${e.id}`}
                    </Tag>
                  ))}
                </div>
              </div>
            );
          })}
      </Modal>
    </>
  );
}

export default forwardRef(SubFlagsModal);
